<template>
    <div style="width: 100%; background: #fff" class="pubmed">
        <div style="width: 100%; background: #F2F2F2; box-shadow: 0 2px rgb(0,0,0,0.6); text-align: center; padding: 30px">
            <a-form :model="pubmed" style="width: 500px; margin: 0 auto" layout="inline" @finish="handleSubmit">
                <a-form-item label="中文Pubmed" name="keyword">
                    <a-input
                            v-model:value="pubmed.keyword"
                            style="width: 300px;"
                            allowClear
                            placeholder="PMID"
                    />
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" html-type="submit">
                        Search
                    </a-button>
                </a-form-item>
            </a-form>
        </div>

        <div style="border: 1px solid #eee; padding: 15px 0; line-height: 1.5">
            <div  class="pubmed-width">

                <a-row>
                    <a-col span="7" v-if="!selected"></a-col>
                    <a-col span="3">{{total_records}} results</a-col>
                    <a-col span="3">
                        <a-checkbox
                                v-model:checked="checkAll"
                                name="ref"
                                :indeterminate="indeterminate"
                                @change="onCheckAllChange"/> All select
                    </a-col>
                    <a-col span="3" v-if="selected > 0">
                        <span style="color: #1F4E79">{{selected}} item selected</span>
                    </a-col>

                    <a-col span="4" v-if="selected > 0">
                <span style="cursor: pointer" @click="onCheckClearChange">
                <CloseOutlined style="margin-right: 5px"/>
                Clear selection
                </span>
                    </a-col>
                    <a-col span="5">
                        Sort by:
                        <a-select
                                style="width: 150px; margin-top: -5px" v-model:value="sortKey"
                                @change="onChangeSortKey"
                        >
                            <a-select-option value="Publish_Date">Publication date</a-select-option>
                        </a-select>
                    </a-col>
                    <a-col span="2">
                    <span style="cursor: pointer" @click="download">
                        <DownloadOutlined style="margin-right: 5px"/>
                        Download
                    </span>
                    </a-col>
                </a-row>
            </div>
        </div>

        <div class="pubmed-width">
            <a-spin :spinning="loading">
                <a-checkbox-group @change="onCheckChange" v-model:value="checkedList">
                    <div class="auto-wrap"
                         style="margin-bottom: 20px;"
                         v-for="(item, index) in current_data" :key="index"
                    >
                        <a-row :gutter="12">

                            <a-col span="2">
                                <p style="text-align: right"><a-checkbox :value="item.paper_no"/> {{pageSize * (page -1) + index +1}}</p>
                            </a-col>
                            <a-col span="22">
                                <p style="cursor: pointer; padding-top: 4px"
                                   @click="function() {
                                     if(!!item.pdf_url) window.open('/Literature/PDF/?path=' + item.pdf_url)
                                   }">{{item[item.titleKey || 'title']}} <a @click="()=>toggleLanguage('title', item, index)">
                                    <TranslationOutlined />
                                </a>
                                </p>
                                <p class="auto-wrap">
                                    <a-space>
                                        <span class="btn" style="color: white; background: #70AD47">
                                            {{item.journal_title}}
                                        </span>
                                        <span class="btn-primary">{{item.pub_date}}</span>
                                        <a class="btn" :href="'/push/paper?paper_no=' + item.paper_no " target="_blank" ref="">
                                            <FilePdfOutlined class="big-icon"/>
                                        </a>

                                        <a-tooltip :title="getMediaText(item.audio_status)">
                                            <a>
                                                <pubmed-media  v-if="item.audio_status === 2" media="audio" :paper-no="item.paper_no" :status="item.audio_status"/>
                                                <AudioOutlined v-else class="big-icon"/>
                                            </a>
                                        </a-tooltip>
                                        <span> </span>
                                        <a-tooltip :title="getMediaText(item.video_status)">
                                            <a v-if="item.video_status === 2">
                                                <VideoCameraOutlined class="big-icon" @click="()=>goToVideo(item.paper_no)"/>
                                            </a>
                                            <a v-else>
                                                <VideoCameraOutlined class="big-icon"/>
                                            </a>
                                        </a-tooltip>

                                    </a-space>
                                </p>
                                <p><b>{{item.summary_brief }}</b></p>
                                <p class="auto-wrap" style="line-height: 24px"><b>Authors:</b> {{item.authors}}</p>
                                <p class="auto-wrap" style="color: #7F7F7F" v-if="item.doi"><b>DOI:</b>{{item.doi}}</p>
                                <p class="auto-wrap" style="color: #7F7F7F" v-if="item.pmid">
                                    <b>PMID:</b>{{item.pmid}}
                                </p>
                                <div class="auto-wrap" style="line-height: 30px; background: #F2F2F2; padding: 15px 10px"
                                     v-if="item.abstract"
                                >
                                    <b>Abstract: </b> <more-o-r-less :text="item[item.abstractKey || 'abstract']" len="60" :noTip="true"/> <a @click="()=>toggleLanguage('abstract', item, index)"><TranslationOutlined /></a>

                                </div>
                            </a-col>
                        </a-row>
                    </div>
                </a-checkbox-group>
                <div style="text-align: right" v-if="!loading">
                    <a-pagination
                            size="small"
                            v-model:current="page"
                            v-model:pageSize="pageSize"
                            :total="total_records"
                            :show-total="total => `${total} items`"
                            show-size-changer
                            :page-size-options="[10,20,50,100,200]"
                            @showSizeChange="onPaginationChange"
                            @change="onPaginationChange"
                    />
                </div>
            </a-spin>
        </div>
    </div>
</template>

<script>
    import {
        CloseOutlined, DownloadOutlined, FilePdfOutlined, TranslationOutlined,
        VideoCameraOutlined,
        AudioOutlined,
    } from '@ant-design/icons-vue';
    import {get_args, isDEV} from "../utils/request";
    import {getMediaText, get_aftergo_paper_list, post_biogpt_push_info, post_biogpt_pubmed_media} from "../utils/bioinfo.api";
    import {jy_tip, setState} from "../utils/vue.tool";
    import MoreORLess from '../components/MoreORLess'
    import PubmedMedia from "./PubmedMedia";
    import {downloadExcel} from "../utils/llm.tools";
    export default {
        name: "PubmedView",
        components: {
            CloseOutlined, DownloadOutlined, FilePdfOutlined, TranslationOutlined,
            VideoCameraOutlined,
            AudioOutlined,
            MoreORLess,
            PubmedMedia
        },
        data(){
            let {keyword, push_no, subscribe_no} = get_args();
            return {
                loading: true,
                selected: 0,
                total_records: isDEV? 1000: 0,
                pubmed: {keyword: isDEV? '40055572': keyword || ''},
                push_no: Number(push_no),
                subscribe_no: Number(subscribe_no),
                page: 1,
                pageSize: isDEV? 1: 20,
                sortKey: 'Publish_Date',
                indeterminate: false,
                checkedList: [],
                current_data: [],
            }
        },
        created(){
            let {page, pageSize, pubmed} = this;
            let {keyword} = pubmed;
            this.get_items(page, pageSize, keyword);
        },
        methods: {
            toggleLanguage(key, item, index){
                let k = key + 'Key';
                if(item[k] && item[k].endsWith('_cn')) item[k] = key;
                else item[k] = key + '_cn';
                console.log(k, item[item[k]]);
                this.current_data[index] = item;
            },
            setState(values, func){
                setState(this, values, func)
            },
            handleSubmit(values) {
                console.log(values);
                let {page, pageSize} = this;
                let {keyword} = values;
                this.get_items(page, pageSize, keyword);
            },
            get_items(page, pageSize, keyword){
                console.log(page, pageSize);
                let obj = this;
                obj.loading = true;
                let {push_no, subscribe_no} = this;
                this.setState({page, pageSize}, ()=>{
                    let rq = {page, size: pageSize};
                    if(keyword) rq = {pmid: keyword, size: pageSize};
                    if(isNaN(push_no)) get_aftergo_paper_list( rq, (response)=>{
                        // let {response} = res;
                        obj.loading = false;
                        if(response){
                            let {data, total_records} = response;
                            obj.handleSort(data, total_records);
                        }
                    });
                    else post_biogpt_push_info({push_no, subscribe_no}, (response)=>{
                        obj.loading = false;
                        if(response){
                            let {data} = response;
                            obj.handleSort(data, data.length);
                        }
                    })
                });
            },
            handleRes(res){
                let {response} = res;
                if(response){
                    let {data, total_records} = response;
                    this.handleSort(data, total_records);
                }
            },
            handleSort(data, total_records){
                data = data || [];
                let {sortKey} = this;
                if(sortKey){
                    data.sort((a, b)=>b[sortKey] - a[sortKey]);
                }
                this.setState({current_data: data, init_data: data, total_records})
            },
            onCheckChange(checkedList){
                let {current_data} = this;
                console.log(checkedList);
                this.setState({
                    checkedList,
                    indeterminate: !!checkedList.length && checkedList.length < current_data.length,
                    checkAll: checkedList.length === current_data.length,
                });
            },
            onCheckAllChange(e) {
                let {current_data} = this;
                let {checked} = e.target;
                let checkedList = checked ? current_data.map(d=>d.paper_no) : [];
                console.log('checkedList', checkedList);
                this.setState({
                    checkedList,
                    indeterminate: false,
                    checkAll: checked,
                });
            },
            onCheckClearChange(){
                this.setState({
                    checkedList: [],
                    indeterminate: false,
                    checkAll: false,
                });
            },
            onFilterYear(){
                let {sortKey, page, pageSize, pubmed: values} = this;
                values = values || {};
                let rq = {page, page_size: pageSize};
                if(sortKey) rq.sort_by = sortKey;
                let {keyword} = values;
                if(keyword)rq = {pmid: keyword};
                get_aftergo_paper_list(rq, (res)=>{
                    this.handleRes(res);
                })
            },
            onChangeSortKey(sortKey){
                this.setState({sortKey}, ()=>{
                    // this.handleSort(data, total_records);
                    this.onFilterYear();
                });
            },
            changeFilterValue(key, value){
                this[key] = value;
            },
            clearYears(){
                this.setState({start_year: '', end_year: ''}, this.onFilterYear)
            },
            download(){
                let {checkedList, current_data} = this;
                if(checkedList.length === 0) {
                    jy_tip('请先选中需要下载的文献！');
                    return;
                }
                let downloadData = current_data.filter(d=>checkedList.indexOf(d.paper_no)>-1);
                downloadExcel('Pubmed_' +(new Date().toLocaleDateString()), downloadData)
            },
            onPaginationChange(page, pageSize){
                this.get_items(page, pageSize, this.pubmed.keyword);
            },
            getMediaText,
            goToVideo(paper_no){
                post_biogpt_pubmed_media('video', {paper_no}, (res)=>{
                    let {data, message} = res;
                    if(data && data.video_url) window.open(data.video_url, '_blank');
                    else jy_tip(message);
                })
            }
        }
    }
</script>

<style scoped>
    .big-icon{
        font-size: 20px;
        cursor: pointer;
    }
    .btn, .btn-primary {
        padding: 5px 8px;
    }
    .btn-primary{
        color: #fff;
        background: #1F4E79;
    }
    .auto-wrap {
        word-wrap: break-word!important; /* 旧版浏览器支持 */
        overflow-wrap: break-word!important; /* 标准属性 */
        word-break: break-all;
        white-space: normal;
        /*white-space: nowrap;不换行*/
    }
    .pubmed-width{
        width: 1200px;
        margin: 10px auto;
        word-wrap: break-word!important; /* 旧版浏览器支持 */
        overflow-wrap: break-word!important; /* 标准属性 */
        word-break: break-all;
    }
    /*{*/
    /*  xs: '480px',*/
    /*  sm: '576px',*/
    /*  md: '768px',*/
    /*  lg: '992px',*/
    /*  xl: '1200px',*/
    /*  xxl: '1600px',*/
    /*}*/
    /* 当视口宽度小于 600px 时 */
    @media (max-width: 480px) {
        .pubmed-width {
            width: 100%;
            border: 1px solid red;
            overflow-wrap: break-word!important; /* 标准属性 */
            word-break: break-all;
        }
    }
</style>
